import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import TailwindLayout from 'TailwindcssComponents/TailwindLayout';
import TopBar from 'TailwindcssComponents/TopBar';
import FooterTailwind from 'TailwindcssComponents/Footer';
import defaultcover from 'assets/images/logos/defaultcover.png';
import 'react-toastify/dist/ReactToastify.css';

export default function SingleVenueCity() {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const bearerToken = localStorage.getItem('token');
    const [cityData, setCityData] = useState(null);
    const { id } = useParams();

    const fetchCityData = async () => {
        try {
            const { data } = await axios.get(`${apiUrl}event-service/city/${id}`);
            if (!data.success) {
                throw new Error(data.message || 'Failed to fetch city data');
            }
            setCityData(data.data);
            console.log(data.data);
        } catch (error) {
            console.error(error?.response?.data?.message || error.message || 'Unknown error occurred');
        }
    };

    useEffect(() => {
        fetchCityData();
    }, [id])

    const handleStatus = async (cityId, newValue) => {
        setCityData(prevData => ({ ...prevData, isActive: newValue }));

        try {
            const endpoint = `${apiUrl}event-service/city/${newValue ? 'active' : 'deactive'}/${cityId}`;
            const { data } = await axios.patch(endpoint, null, {
                headers: { Authorization: `Bearer ${bearerToken}` },
            });

            toast.success(data.message || `Venue City ${newValue ? 'Activated' : 'Deactivated'} Successfully!`);
        } catch (error) {
            // Revert state if API fails
            setCityData(prevData => ({ ...prevData, isActive: !newValue }));
            toast.error(`Unable to ${newValue ? 'activate' : 'deactivate'} venue city!` || error.response?.data?.message || error.message);
        }
    };

    return (
        <TailwindLayout>
            <TopBar />
            <div className="p-12 bg-gray-100 min-h-screen mb-8">
                <div
                    className="relative flex items-center min-h-[300px] rounded-xl bg-cover bg-center overflow-hidden"
                    style={{
                        backgroundImage: `linear-gradient(rgba(59, 130, 246, 0.6), rgba(37, 99, 235, 0.6)), url(${cityData?.image?.secure_url || defaultcover})`
                    }}
                />

                {cityData && (
                    <>
                        <div className="relative -mt-32 mx-4 bg-white rounded-2xl shadow-xl mb-16 overflow-hidden">
                            <div className="px-6 py-4">
                                <h1 className="text-2xl font-semibold mb-2">{cityData.name}</h1>
                            </div>

                            <div className="px-6 py-4">
                                <div className="flex flex-wrap items-center gap-8">
                                    <div className="flex items-center gap-3">
                                        <span className="text-sm font-medium text-gray-900">Status:</span>
                                        <label className="relative inline-flex items-center cursor-pointer">
                                            <span className={`mr-2 text-sm ${cityData.isActive ? 'text-gray-500' : 'font-medium text-gray-900'}`}>
                                                Inactive
                                            </span>
                                            <input
                                                type="checkbox"
                                                className="sr-only peer"
                                                checked={cityData.isActive}
                                                onChange={(e) => handleStatus(cityData.id, e.target.checked)}
                                            />
                                            <div className="w-12 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full relative transition-all peer-checked:bg-blue-600">
                                                <div className={`absolute top-1 left-1 w-4 h-4 bg-white border border-gray-300 rounded-full transition-all ${cityData.isActive ? "translate-x-6 border-white" : ""}`} />
                                            </div>
                                            <span className={`ml-2 text-sm ${cityData.isActive ? 'font-medium text-gray-900' : 'text-gray-500'}`}>
                                                Active
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="px-6 py-4">
                                <div className="flex items-start gap-2">
                                    <svg className="w-5 h-5 text-gray-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                                    </svg>
                                    <div>
                                        <span className="text-sm font-medium text-gray-900 block mb-1">Description</span>
                                        <p className="text-sm text-gray-600">
                                            {cityData.description.length > 50
                                                ? cityData.description.replace(/<[^>]*>/g, '').substring(0, 50) + '...'
                                                : cityData.description.replace(/<[^>]*>/g, '')}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="px-6 py-4">
                                <iframe
                                    src={cityData?.location}
                                    className='w-full h-50 rounded-lg'
                                />
                            </div>
                        </div>
                    </>
                )}

            </div>
            <FooterTailwind />
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </TailwindLayout>
    )
}